import { all, call, delay, put, takeLatest } from 'redux-saga/effects'
import { calculateEvents, IActionLoadCalendars, removeExpiredEvents } from '../actions/event'
import { EVENT_LOAD_CALENDARS } from '../constants/ActionTypes'
import { Calendar } from '../model/Calendar'
import { Device } from '../model/Device'
import { Event } from '../model/Event'
import { fetchFile } from '../services/axios'
import { ISettings } from '../services/hashParser'
import { parseCalendar } from '../services/icsParser'

function* loadCalendars(action: IActionLoadCalendars) {
  const { calendars, eventInterval, settings, device } = action

  const parsedEvents = yield all(calendars.map((calendar: Calendar) => call(
    loadCalendar,
    calendar,
    eventInterval,
    settings,
    device,
  )))
  const mergedEvents: Event[] = [].concat.apply([], parsedEvents)

  yield put(calculateEvents(mergedEvents))
}

function* loadCalendar( // Runs parallel for each defined calendar
  calendar: Calendar,
  eventInterval: number,
  settings: ISettings,
  device: Device,
) {
  if (calendar.url) {
    try {
      const response = yield call(fetchFile, calendar.url)
      return yield call(parseCalendar, calendar, eventInterval, settings, device, response.data)
    } catch (e) {
      console.error(e)
    }
  } else {
    console.error('Calendar file was not specified.')
  }
}

function* removeExpired() {
  while (true) {
    yield put(removeExpiredEvents())
    yield delay(10000)
  }
}

export function* eventSaga() {
  yield all([
    takeLatest(EVENT_LOAD_CALENDARS, loadCalendars),
    removeExpired(),
  ])
}
